import { SubscriptionStatus, UserSubscription } from 'types/subscription';

export const STRIPE_ENDED_STATUSES = [
  'canceled',
  'unpaid',
  'incomplete_expired',
] as const;

export type StripeEndedStatus = typeof STRIPE_ENDED_STATUSES[number];

export function isPaidPlanTrialPeriod(
  subscription?: UserSubscription | null,
): boolean {
  if (!subscription?.subscriptionPlan) return false;

  if (subscription.planId === SubscriptionStatus.TRIAL) return false;
  if (subscription.stripeSubscriptionStatus === 'trialing') return true;
  if (subscription.status === SubscriptionStatus.TRIAL) return true;
  return false;
}

export function isStripeSubscriptionFullyEnded(
  subscription?: UserSubscription | null,
): boolean {
  const status = subscription?.stripeSubscriptionStatus;
  if (!status) return false;
  return (STRIPE_ENDED_STATUSES as readonly string[]).includes(status);
}

/** App-level cancelled when Stripe has not fully ended the subscription. */
export function isLegacyAppCancelled(
  subscription?: UserSubscription | null,
): boolean {
  if (!subscription) return false;
  if (isStripeSubscriptionFullyEnded(subscription)) return false;
  return (
    subscription.status === SubscriptionStatus.CANCELLED &&
    subscription.subscriptionId !== SubscriptionStatus.MIGRATED
  );
}

export function getStripeSubscriptionEndIso(
  subscription?: UserSubscription | null,
): string | null | undefined {
  const sub = subscription;
  if (!sub) return undefined;

  if (isStripeSubscriptionFullyEnded(sub)) {
    return (
      sub.stripeEndedAt ||
      sub.stripeCancelAt ||
      sub.stripeCurrentPeriodEnd ||
      sub.endDate ||
      undefined
    );
  }

  if (
    sub.stripeSubscriptionStatus === 'active' &&
    sub.stripeCancelAtPeriodEnd
  ) {
    return sub.stripeCancelAt || sub.stripeCurrentPeriodEnd || undefined;
  }

  return sub.stripeCurrentPeriodEnd || sub.endDate || undefined;
}
